import { BackendServiceUrl, BadRequestError, BaseService, ConflictError } from './BaseService';
import { HostContext } from '../../embed-script/HostContext';

export interface CallbackResult {
    success: boolean;
    errorMessage?: string;
    statusCode?: number;
}

export interface QueueStatus {
    status: 'Open' | 'Closed';
}

export class CallbackService extends BaseService {
    constructor(accessToken: string, baseServiceUrl: string = BackendServiceUrl) {
        super(accessToken, baseServiceUrl);
    }

    public async getQueueStatusAsync(hostContext?: HostContext): Promise<QueueStatus> {
        const result = await this.getResponseAsync<QueueStatus>({
            commandPath: '/callbacks/status',
            method: 'GET',
            hostContext,
        });
        return result;
    }

    public async requestCallbackAsync(
        phoneNumber: string,
        chatId: string,
        hostContext?: HostContext,
    ): Promise<CallbackResult> {
        try {
            await this.getResponseAsync({
                commandPath: '/callbacks',
                method: 'POST',
                body: { phoneNumber, chatId },
                hostContext,
            });
            return { success: true };
        } catch (error) {
            if (error instanceof ConflictError) {
                return {
                    success: false,
                    errorMessage: 'callback.alreadyScheduledMessage',
                    statusCode: 409,
                };
            }
            if (error instanceof BadRequestError) {
                return {
                    success: false,
                    errorMessage: 'callback.invalidPhoneNumberMessage',
                    statusCode: 400,
                };
            }

            return {
                success: false,
                errorMessage: 'callback.errorMessage',
            };
        }
    }
}
